import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  dropdown: {
    minWidth: '45% !important',
    width:'-webkit-fill-available',
    borderColor: 'transparent',
    '& .MuiSelect-select': {
      height: 'auto',
      padding: '0px !important',
      backgroundColor: 'transparent !important',
      border: 'none',
      borderColor: 'transparent',
      boxShadow: 'none !important',
      fontFamily:'ActoMedium !important',
      fontSize:'14px !important',
      color: theme.palette.primary.medium,
    },
    '& .MuiSelect-icon': {
      color: 'red',
      marginLeft:10
    },
    '& .MuiSvgIcon-root': {
      boxShadow: 'none',
      borderColor: 'transparent',
      color: 'red !important', // Cambia el color de la flecha a rojo
    },
  },
  dropdownMenu: {},
  hiddenSelect: {
    backgroundColor: 'transparent',
    padding: '0px',
  },
}))

export default useStyles
